/**
 * Session headline KPI row (top of page, above the topology): live throughput,
 * payments settled, fraud blocked, and sanctions caught.
 *
 * The counters mirror the scoreboard's cumulative session counters (scoreboard.ts),
 * so there is exactly one place that counts settled payments / fraud / sanctions.
 */

function setText(doc: Document, sel: string, txt: string): void {
  const el = doc.querySelector(sel);
  if (el) el.textContent = txt;
}

export interface KpiInputs {
  tps: number;
  p95Ms: number;
  settledCount: number;
  fraudCount: number;
  sanctionsCount: number;
}

export function renderKpiRow(doc: Document, k: KpiInputs): void {
  setText(doc, '[data-kpi="tps"]', `${Math.round(k.tps * 10) / 10} req/s`);
  setText(doc, '[data-kpi="p95"]', `${Math.round(k.p95Ms)}ms`);
  setText(doc, '[data-kpi="settled"]', String(k.settledCount));
  setText(doc, '[data-kpi="fraud"]', String(k.fraudCount));
  setText(doc, '[data-kpi="sanctions"]', String(k.sanctionsCount));
}
